import {isEmpty} from "lodash"
import {CLONE_STATUS_NEW, ENABLED} from "@irati/insights/constants/question"

const getNewQuestionsRequests = (questions = [], tenantUuid, questionGroupId, driverUuid) => {
  const validQuestions = questions.filter(({status, groupUuids}) => status === CLONE_STATUS_NEW && isEmpty(groupUuids))
  return validQuestions.map((question) => {
    return {
      ...question,
      tenantUuid,
      groupUuids: [questionGroupId],
      driverUuid,
      driverId: undefined,
      id: undefined,
      etag: undefined,
      createdAt: undefined,
      status: ENABLED
    }
  })
}

export default getNewQuestionsRequests
